import React, { FC } from "react";

import {
  useApisMembersInsightPostCommentsLikedEmployeesIndex,
  useArray,
} from "~/hooks";

import { ReactedEmployeesModal } from "~/components/molecules";

import { ReactedEmployeeType } from "~/domains";

type PropsType = {
  insightPostCommentId: string;
  onClose: () => void;
};

export const InsightPostCommentsLikedEmployeesModal: FC<PropsType> = ({
  insightPostCommentId,
  onClose,
}: PropsType) => {
  const { items, setItems } = useArray<ReactedEmployeeType>([]);
  const { fetchNextPage, hasNextPage, isLoading } =
    useApisMembersInsightPostCommentsLikedEmployeesIndex({
      insightPostCommentId,
      config: {
        onSuccess: (data) => {
          setItems(
            data.pages.map((page) => page.insightPostCommentLikes).flat(),
          );
        },
      },
    });
  return (
    <ReactedEmployeesModal
      headerTitle="いいねしたユーザー"
      onClose={onClose}
      reactedEmployees={items}
      nextFetchFunction={fetchNextPage}
      hasMore={hasNextPage}
      isLoading={isLoading}
    />
  );
};
